import tippy from 'tippy.js';

export function initializeCellPreviews(element) {
    element.querySelectorAll('[data-cell-preview]').forEach(chip => {
        if (chip._tippy) {
            return;
        }

        const content = document.createElement('div');
        content.appendChild(chip.parentElement.querySelector('[data-cell-preview-content]').content.cloneNode(true));

        tippy(chip, {
            content,
            theme: 'light-border cell-preview',
            placement: 'top',
            arrow: true,
            maxWidth: 360,
            trigger: window.matchMedia('(hover: hover)').matches ? 'mouseenter focus' : 'click',
        });
    });
}
